import { render, staticRenderFns } from "./other-cost.vue?vue&type=template&id=7607823c"
import script from "./other-cost.vue?vue&type=script&lang=js"
export * from "./other-cost.vue?vue&type=script&lang=js"
import style0 from "./other-cost.vue?vue&type=style&index=0&id=7607823c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports